import { PageId } from 'constants/pages'
import { getPageById } from 'nove8/helpers/getPageById'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_PUP_DRSL: TStep[] = [
  {
    pageId: PageId.DOG_AGE_PUP_DRSL,
  },
  {
    pageId: PageId.DOG_OWNER_PUP_DRSL,
  },
  {
    pageId: PageId.TRAINING_COMMANDS_PUP_DRSL,
  },
  {
    pageId: PageId.URGE_PAGE_PUP_DRSL,
  },
  {
    pageId: PageId.DOG_BREED_PUP_DRSL,
  },
  {
    pageId: PageId.FACING_CHALLENGES_PUP_DRSL,
  },
  {
    pageId: PageId.FACING_CHALLENGES_2_PUP_DRSL,
  },
  {
    pageId: PageId.BEHAVIOR_FREQUENCY_PUP_DRSL,
  },
  {
    pageId: PageId.URGE_PROGRAM_PUP_DRSL,
  },
  {
    pageId: PageId.BEHAVIOR_FEELINGS_PUP_DRSL,
  },
  {
    pageId: PageId.FIX_BEHAVIOR_PUP_DRSL,
  },
  {
    pageId: PageId.URGE_PAGE_4_PUP_DRSL,
  },
  {
    pageId: PageId.COMMANDS_PUP_DRSL,
  },
  {
    pageId: PageId.PARENT_GOAL_PUP_DRSL,
  },
  {
    pageId: PageId.TRAINING_PLACE_PUP_DRSL,
  },
  {
    pageId: PageId.TRAINING_FREQUENCY_PUP_DRSL,
  },
  {
    pageId: PageId.URGE_PAGE_5_PUP_DRSL,
  },
  {
    pageId: PageId.PREPARE_FLOW_PUP_DRSL,
  },
  {
    pageId: PageId.EMAIL_PUP_DRSL,
  },
  {
    pageId: PageId.NEWSLETTER_URGE_PUP_DRSL,
  },
  {
    pageId: PageId.SUBSCRIPTIONS_PUP_DRSL,
  },
  {
    pageId: PageId.CHAT_UPSELL_PUP_DRSL,
  },
  {
    pageId: PageId.UPSELL_PUP_DRSL,
  },
  {
    pageId: PageId.UPSELL_FEEDING_GUIDE_PUP_DRSL,
  },
  {
    pageId: PageId.UPSELL_EMOTIONAL_SUPPORT_PUP_DRSL,
  },
  {
    pageId: PageId.DOWNLOAD_PUP_DRSL,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_PUP_DRSL.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar,
)
  .filter(({ pageId }) => !getPageById(pageId)?.progressBarHidden)
  .map(({ pageId }) => pageId)

export const CONTROLLED_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_PUP_DRSL.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar === 'controlled',
).map(({ pageId }) => pageId)

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS_TEST_B = [
  PageId.FACING_CHALLENGES_PUP_DRSL,
  PageId.FACING_CHALLENGES_2_PUP_DRSL,
  PageId.DOG_BREED_PUP_DRSL,
  PageId.BEHAVIOR_FEELINGS_PUP_DRSL,
  PageId.FIX_BEHAVIOR_PUP_DRSL,
  PageId.PARENT_GOAL_PUP_DRSL,
  PageId.TRAINING_PLACE_PUP_DRSL,
  PageId.TRAINING_FREQUENCY_PUP_DRSL,
]

export const CONTROLLED_PAGES_WITH_PROGRESS_BAR_IDS_TEST_B = [
  PageId.FACING_CHALLENGES_PUP_DRSL,
  PageId.FACING_CHALLENGES_2_PUP_DRSL,
  PageId.DOG_BREED_PUP_DRSL,
  PageId.BEHAVIOR_FEELINGS_PUP_DRSL,
  PageId.FIX_BEHAVIOR_PUP_DRSL,
  PageId.PARENT_GOAL_PUP_DRSL,
  PageId.TRAINING_PLACE_PUP_DRSL,
  PageId.TRAINING_FREQUENCY_PUP_DRSL,
]
